// extracted by mini-css-extract-plugin
export default {"element":"Introduction-module--element--65990","container":"Introduction-module--container--8caa7","wide":"Introduction-module--wide--4cfda"};